import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDashboardLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={20}
    height={20}
    fill='currentColor'
    viewBox='0 0 20 21'
    {...props}
  >
    <path d='M10 4.177a5.833 5.833 0 1 1 0 11.667 5.833 5.833 0 0 1 0-11.667M10 .01a10 10 0 1 0 0 20 10 10 0 0 0 0-20' />
  </svg>
);
export default SvgDashboardLogo;
